// extracted by mini-css-extract-plugin
export var hasMaxWidth = "Image-module--hasMaxWidth--64a4c";
export var imageWrapper = "Image-module--imageWrapper--5cf54";
export var rounded = "Image-module--rounded--0e620";